<template>
	<div class="public-certificate-page">
		<Loading :show="loading" label="3, 2, 1..." />
		<iframe v-if="pdfObjectUrl" :src="pdfObjectUrl" class="certificate-pdf-frame" title="Certificate" />
	</div>
</template>

<script>
import Loading from 'vue-full-loading';
import axios from 'axios';

/** PDF open params hint for Chromium’s built-in viewer (iframe). Other browsers may ignore. */
const PDF_IFRAME_VIEW_HASH = '#toolbar=0&navpanes=0';

export default {
	name: 'PublicViewCertificatePage',
	components: {
		Loading,
	},
	data() {
		return {
			loading: false,
			pdfObjectUrl: null,
		};
	},
	watch: {
		'$route.params.slug'() {
			this.fetchCertificateFile();
		},
	},
	beforeDestroy() {
		this.revokeCertificatePdfUrl();
	},
	methods: {
		/**
		 * Releases the blob URL for the embedded PDF to avoid leaking object URLs.
		 *
		 * @changed_at 02/04/2026 by AI (GPT-5.2)
		 */
		revokeCertificatePdfUrl() {
			if (this.pdfObjectUrl) {
				const blobUrlWithoutHash = this.pdfObjectUrl.split('#')[0];
				URL.revokeObjectURL(blobUrlWithoutHash);
				this.pdfObjectUrl = null;
			}
		},

		/**
		 * Navigates to the global not-found view (catch-all route).
		 *
		 * @changed_at 02/04/2026 by AI (GPT-5.2)
		 */
		goToPageNotFound() {
			this.$router.replace('/page-not-found');
		},

		/**
		 * Loads the public certificate PDF for the current route slug and exposes it as a blob URL for the iframe.
		 *
		 * @changed_at 02/04/2026 by AI (GPT-5.2)
		 */
		async fetchCertificateFile() {
			this.revokeCertificatePdfUrl();
			try {
				this.loading = true;
				const slug = this.$route.params.slug;
				const response = await axios.get(`/api/certificates/public/file/${slug}`, {
					responseType: 'blob',
					validateStatus: () => true,
				});
				const contentType = (response.headers && response.headers['content-type']) || '';
				if (response.status === 200 && contentType.includes('application/pdf')) {
					this.pdfObjectUrl = `${URL.createObjectURL(response.data)}${PDF_IFRAME_VIEW_HASH}`;
					return;
				}
				this.goToPageNotFound();
			} catch (error) {
				console.error('Error fetching certificate file:', error);
				this.goToPageNotFound();
			} finally {
				this.loading = false;
			}
		},
	},

	mounted() {
		this.fetchCertificateFile();
	},
};
</script>

<style scoped lang="scss">
.public-certificate-page {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
}

.certificate-pdf-frame {
	flex: 1;
	width: 100%;
	min-height: 100vh;
	border: 0;
}
</style>
